import React, {Component} from "react";
import logo from "./logo.png";
import arrow from "./arrow.png";
import cross from "./cross.png";
import warning from "./warning.png";

const translate = require('../../../../translate');

const Error = ({ error }) => {
  return <div className='text-light'>{error}</div>;
};

const MissingToken = () => {
  return <div className='text-light'>Missing token</div>;
};

const StatusHeader = ({screen, t}) => {
  let text = t('Enter')
  if(screen === 'waitState') text = t('Stop')
  if(screen === 'closed') text = t('Closed')

  let fontSize = text.length > 10 ? '12vh' : (text.length > 6 ? '24vh' : '27vh')
  let bottom = text.length > 10 ? '50vh' : '45vh'
  if(text.includes('\n')) {
    bottom = '42vh'
    fontSize = '14vh'
  }
  return (<div style={{
    position: 'absolute', left: '11vh', bottom,
    maxWidth: '47vw',
    fontSize,
    fontWeight: 'bold',
    lineHeight: 1,
    whiteSpace: 'pre-wrap',}}
  >
    {text}
  </div>)
}

export class Default extends Component {

  render() {
    let {data, screen, language, err, hideNumbers} = this.props;
    let t = (...args) => translate(language, ...args)

    console.log(this.props);

    let mayEnter = data.maxOccupancy ? data.maxOccupancy - data.currentOccupancy : null;
    if(mayEnter < 0) mayEnter = 0;

    let isCritical = mayEnter <= 10 && mayEnter > 0;
    let closed = screen === 'closed'
    let withoutLimits = screen === 'withoutLimits'

    let background = '#000';
    if (screen === 'enterState' || withoutLimits) {
      background = isCritical ? '#ff771c' : '#00a01e';
    } else if (screen === 'waitState' || closed) {
      background = '#ff2c1c';
    } else if(!screen) {
      document.body.style.backgroundColor = background;
      return <div/>
    }

    document.body.style.backgroundColor = background;

    if(screen === 'errorState') return <Error error={err}/>
    if(screen === 'missingToken') return <MissingToken />

    let maxOccupancyColor = '#00dc29';
    if(isCritical) maxOccupancyColor = '#ffcead';
    if(screen === 'waitState') maxOccupancyColor = '#ffaeae';

    let image = arrow;
    if(isCritical) image = warning;
    if(screen === 'waitState' || closed) image = cross;

    let mayEnterText = t('PEOPLE MAY ENTER 5');
    if(mayEnter === 1) mayEnterText = t('PEOPLE MAY ENTER 1');
    if(mayEnter >= 2 && mayEnter < 5) mayEnterText = t('PEOPLE MAY ENTER 2');

    return (
      <div className='text-light'>
        <img style={{position: 'absolute', left: '12vh', top: '12vh',
          height: '2.4vh',
        }} src={logo} alt="Pygmalios" className="app-logo"/>

        <StatusHeader t={t} screen={screen} />

        {!closed && !withoutLimits && <div style={{
          position: 'absolute', left: '57vw', top: '32vh',
          fontSize: '7vh',
          fontWeight: 'bold',
          lineHeight: 1.2,
          whiteSpace: 'pre-wrap',
        }}>
          {isCritical && t('The Occupancy\nlimit will be\nreached soon.')}
          {screen === 'waitState' && t('Wait, please\nMaximum Capacity\nwas reached.')}
        </div>}

        {!closed && !hideNumbers && <div style={{position: 'absolute', left: '12vh', top: '73vh',}}>
          <div style={{lineHeight: 1, position: 'relative', left: '-0.5vw'}}>
            <span style={{fontSize: '12vh', fontWeight: 'bold'}}>{data.currentOccupancy}</span>
            { !withoutLimits && <span style={{fontSize: '6vh', color: maxOccupancyColor}}> / {data.maxOccupancy}</span>}
          </div>
          <div style={{fontSize: '3.5vh', fontWeight: 'bold', position: 'relative', left: '-0.5vw'}}>
            {t('CURRENT OCCUPANCY')}
          </div>
        </div>}

        {!closed && !withoutLimits && !hideNumbers && <div style={{position: 'absolute', left: '57vw', top: '73vh',}}>
          <div style={{lineHeight: 1, position: 'relative', left: '-0.5vw', fontSize: '12vh', fontWeight: 'bold'}}>
            {mayEnter}
          </div>
          <div style={{fontSize: '3.5vh', fontWeight: 'bold', position: 'relative', left: '-0.5vw'}}>
            {mayEnterText}
          </div>
        </div>}

        <img style={{position: 'absolute', top: '16vh', left: '67vw', zIndex: -1, width: '37vw', }} src={image} alt=""/>
      </div>
    )
  }
}
